import React, { useState } from "react";
import { AppConfigContext } from "./context";

const AppConfigProvider: React.FC = (props) => {
  const [fullscreen, setFullscreen] = useState(false);
  return (
    <AppConfigContext.Provider value={[fullscreen, setFullscreen]}>
      {props.children}
    </AppConfigContext.Provider>
  );
};

export default AppConfigProvider;
